import { Helpers } from '../../helpers';
import { ILease } from '../../interfaces/ilease';
import { Area } from '../area';
import { ConstraintLeaseObligation } from '../constraint-lease-obligation';
import { ContinuousDrillingObligation } from '../continuous-drilling-obligation';
import { County } from '../county';
import { LeaseStatus } from '../lease-status';
import { Township } from '../township';
import { Tract } from '../tract';

export class LeaseBase {
  LeaseId: number;
  TractId: number | null;
  Name: string | null;
  FileNumber: string | null;
  AgreementNumber: string | null;
  AgreementName: string | null;
  ExpirationDate: Date | null;
  CriticalDateComments: string | null;
  Section: number | null;
  Block: number | null;
  TownshipId: number | null;
  Survey: string | null;
  BaseLeaseAcreage: string | null;
  DrilledToDensity: boolean | null;
  LeaseStatusId: number | null;
  NetArea: number | null;
  AgreementDate: Date | null;
  CompanyNetInterest: number | null;
  LessorInterest: number | null;
  AgreementKey: string | null;
  AgreementPrintKey: string | null;
  AgreementProperty: string | null;
  Comments1: string | null;
  Comments2: string | null;
  CriticalDate: Date | null;
  CriticalDate1: Date | null;
  CriticalDate2: Date | null;
  CricitialDate3: Date | null;
  DisplayName: string | null;
  IsHeldByProduction: boolean | null;
  LandResponse: string | null;
  Landman: string | null;
  AgreementAreaDescription: string | null;
  ContractNumber: string | null;
  Lessor: string | null;
  ObligationQuarter: string | null;
  StipulationKey: string | null;
  GeosRecommendation: string | null;
  ObligationComments: string | null;
  PNRDepthFrom: number | null;
  PNRDepthTo: number | null;
  SubdivisionLabel: string | null;
  CountyId: number | null;
  AreaId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstraintLeaseObligations_Lease?: Array<ConstraintLeaseObligation> | null;
  ContinuousDrillingObligations_Lease?: Array<ContinuousDrillingObligation> | null;
  Area?: Area;
  County?: County;
  LeaseStatus?: LeaseStatus;
  Township?: Township;
  Tract?: Tract;

  constructor(item?: ILease) {
    if (item) {

      this.LeaseId = item.LeaseId;
      this.TractId = item.TractId;
      this.Name = item.Name;
      this.FileNumber = item.FileNumber;
      this.AgreementNumber = item.AgreementNumber;
      this.AgreementName = item.AgreementName;
      this.ExpirationDate = item.ExpirationDate ? new Date(item.ExpirationDate) : null;
      this.CriticalDateComments = item.CriticalDateComments;
      this.Section = item.Section;
      this.Block = item.Block;
      this.TownshipId = item.TownshipId;
      this.Survey = item.Survey;
      this.BaseLeaseAcreage = item.BaseLeaseAcreage;
      this.DrilledToDensity = item.DrilledToDensity;
      this.LeaseStatusId = item.LeaseStatusId;
      this.NetArea = item.NetArea;
      this.AgreementDate = item.AgreementDate ? new Date(item.AgreementDate) : null;
      this.CompanyNetInterest = item.CompanyNetInterest;
      this.LessorInterest = item.LessorInterest;
      this.AgreementKey = item.AgreementKey;
      this.AgreementPrintKey = item.AgreementPrintKey;
      this.AgreementProperty = item.AgreementProperty;
      this.Comments1 = item.Comments1;
      this.Comments2 = item.Comments2;
      this.CriticalDate = item.CriticalDate ? new Date(item.CriticalDate) : null;
      this.CriticalDate1 = item.CriticalDate1 ? new Date(item.CriticalDate1) : null;
      this.CriticalDate2 = item.CriticalDate2 ? new Date(item.CriticalDate2) : null;
      this.CricitialDate3 = item.CricitialDate3 ? new Date(item.CricitialDate3) : null;
      this.DisplayName = item.DisplayName;
      this.IsHeldByProduction = item.IsHeldByProduction;
      this.LandResponse = item.LandResponse;
      this.Landman = item.Landman;
      this.AgreementAreaDescription = item.AgreementAreaDescription;
      this.ContractNumber = item.ContractNumber;
      this.Lessor = item.Lessor;
      this.ObligationQuarter = item.ObligationQuarter;
      this.StipulationKey = item.StipulationKey;
      this.GeosRecommendation = item.GeosRecommendation;
      this.ObligationComments = item.ObligationComments;
      this.PNRDepthFrom = item.PNRDepthFrom;
      this.PNRDepthTo = item.PNRDepthTo;
      this.SubdivisionLabel = item.SubdivisionLabel;
      this.CountyId = item.CountyId;
      this.AreaId = item.AreaId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstraintLeaseObligations_Lease = Helpers.createClassArray(ConstraintLeaseObligation, item.ConstraintLeaseObligations_Lease);
      this.ContinuousDrillingObligations_Lease = Helpers.createClassArray(ContinuousDrillingObligation, item.ContinuousDrillingObligations_Lease);
      this.Area = new Area(item.Area);
      this.County = new County(item.County);
      this.LeaseStatus = new LeaseStatus(item.LeaseStatus);
      this.Township = new Township(item.Township);
      this.Tract = new Tract(item.Tract);
    }
  }
}